import {Box} from '@mui/material';
import {useContext} from 'react';
import {AppContext} from '../../contexts/app/context';
import {AppContextType} from '../../contexts/app/types';
import {OfficeContext} from '../../contexts/office/context';
import {OfficeContextType} from '../../contexts/office/types';
import {LoadingContent} from './loading-content';

/**
 * Loading indicator positioned in the center of the page.
 */
export const LoadingContentAbsolute = () => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);
  const officeContext: OfficeContextType = useContext(OfficeContext);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%)',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        paddingLeft: officeContext.state.drawerOpened
          ? `${appContext.state.currentThemeSettings.drawerWidth}px`
          : '0px',
      }}
    >
      <LoadingContent />
    </Box>
  );
};
